import {
  faCircleNotch,
  faPaperPlane,
  faPaperclip,
  faSpinner,
  faWindowMinimize,
  faX,
  faAngleRight,
  faMinus,
  faFilter,
  faCircleQuestion,
  faBars,
  faDownload,
  faCirclePlus,
  faCircleXmark,
  faCircleExclamation,
  faThumbtack as faThumbtackSolid,
  faUpRightAndDownLeftFromCenter,
  faDownLeftAndUpRightToCenter,
} from '@fortawesome/free-solid-svg-icons';
import { faLightbulbExclamationOn } from '@fortawesome/pro-solid-svg-icons';
import { faEyeSlash, faSuitcase, faFileLines } from '@fortawesome/pro-light-svg-icons';
import {
  faNoteSticky,
  faThumbtack as faThumbtackRegular,
  faFaceLaughWink,
} from '@fortawesome/pro-regular-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';

library.add(
  faCircleNotch,
  faPaperPlane,
  faPaperclip,
  faSpinner,
  faWindowMinimize,
  faX,
  faAngleRight,
  faMinus,
  faFilter,
  faLightbulbExclamationOn,
  faEyeSlash,
  faCircleQuestion,
  faBars,
  faSuitcase,
  faFileLines,
  faDownload,
  faNoteSticky,
  faCirclePlus,
  faCircleXmark,
  faCircleExclamation,
  faThumbtackSolid,
  faThumbtackRegular,
  faUpRightAndDownLeftFromCenter,
  faDownLeftAndUpRightToCenter,
  faFaceLaughWink,
);
